import { createContext, useContext } from "react";

export type YachtContent = {
  berthID: any;
  setBerthID: (c: string) => void;
};
export const YachtContext = createContext<YachtContent>({
  berthID: "", // set a default value
  setBerthID: () => {},
});
export const useYachtContext = () => useContext(YachtContext);
